"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var DomWidgets_1 = require("./DomWidgets");
var TabStyles_1 = require("../styles/TabStyles");
var RadioButtonWithLabelWidget_1 = require("./RadioButtonWithLabelWidget");
var DomUtil_1 = require("../utils/DomUtil");
var RadioLayoutType;
(function (RadioLayoutType) {
    RadioLayoutType[RadioLayoutType["Veritical"] = 0] = "Veritical";
    RadioLayoutType[RadioLayoutType["Horizontal"] = 1] = "Horizontal";
})(RadioLayoutType = exports.RadioLayoutType || (exports.RadioLayoutType = {}));
/** Controlled, stateless Radio Button Label Group Widget. */
var RadioButtonWithLabelGroupWidget = /** @class */ (function (_super) {
    tslib_1.__extends(RadioButtonWithLabelGroupWidget, _super);
    function RadioButtonWithLabelGroupWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.groupId = DomUtil_1.generateId();
        return _this;
    }
    RadioButtonWithLabelGroupWidget.prototype.getContainerStyleOfIndex = function (index) {
        if (index !== this.props.buttonList.length - 1) {
            if (this.props.layout === RadioLayoutType.Horizontal) {
                return {
                    paddingRight: TabStyles_1.TabStyles.Spacing.ExtraLargeSpace,
                };
            }
        }
        return {};
    };
    RadioButtonWithLabelGroupWidget.prototype.getContainerStyle = function () {
        var styles = {};
        if (this.props.layout === RadioLayoutType.Horizontal) {
            styles.display = 'flex';
            styles.flexWrap = 'wrap';
            if (this.props.justifyHorizontalItems) {
                styles.justifyContent = 'space-between';
            }
        }
        return styles;
    };
    RadioButtonWithLabelGroupWidget.prototype.render = function () {
        var _this = this;
        var buttons = this.props.buttonList.map(function (buttonOption, index) {
            return React.createElement(RadioButtonWithLabelWidget_1.RadioButtonWithLabelWidget, tslib_1.__assign({}, buttonOption, { checked: index === _this.props.checkedIndex, containerStyle: _this.getContainerStyleOfIndex(index), groupName: _this.props.name || "RadioButtonWithLabelGroup-" + _this.groupId, handleChange: _this.props.handleChange, index: index, key: index, removeLeftMargin: _this.props.removeLeftMargin }));
        });
        return (React.createElement(DomWidgets_1.Block, { "aria-label": this.props.ariaLabel, children: buttons, "data-tb-test-id": "RadioButtonWithLabelGroupWidget-" + this.props.testId, role: 'radiogroup', style: this.getContainerStyle() }));
    };
    return RadioButtonWithLabelGroupWidget;
}(React.Component));
exports.RadioButtonWithLabelGroupWidget = RadioButtonWithLabelGroupWidget;
//# sourceMappingURL=RadioButtonWithLabelGroupWidget.js.map